



















































import { convertFileToBase64, formatBytes, getProgressBarSpeedlimit, getRandomNumber, isEmptyObject } from '@/util';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';
import BaseApi from '@/api/base';
import CloseIcon from '@/assets/icons/CloseIcon.vue';
import UploadIcon from '@/assets/icons/UploadIcon.vue';
import InfoIcon from '@/assets/icons/InfoIcon.vue';
import { scanFile, uploadAttachment, uploadPhoto } from '@/api';
import { UploadStatus, EventType } from '@/constants';
import { Attachment, Photos } from '@/types';

export default Vue.extend({
  name: 'Attachmnent',
  components: {
    CloseIcon,
    InfoIcon,
    UploadIcon
  },
  data () {
    return {
      progress: 0,
      uploadStatus: UploadStatus.PENDING,
      uploading: false,
      base64FileData: '',
      scanResult: '',
      uploadUrl: '',
      maxProgressUpdateLimit: {} as any,
      scanData: {} as any,
      UploadStatus,
      EventType,
      attachmentDescription: ''
    }
  },
  props: {
    attachment: {
      type: Object as PropType<Attachment>,
      required: true
    },
    activeConversation: {
      type: String,
      required: false
    },
    attachments: {
      type: Array as PropType<Attachment[]>,
      required: true
    },
    jobId: {
      type: String || null,
      required: false
    }
  },
  computed: {
    ...mapGetters(['selectedJob', 'user']),
    fileSize (): string {
      return formatBytes(this.attachment.file.size);
    },
    prevAttachment (): Attachment {
      return this.attachments.find(attachment => attachment.id === this.attachment.prev) || {} as Attachment;
    },
    prevAttachmentStatus (): string {
      return this.prevAttachment?.status || '';
    }
  },
  watch: {
    prevAttachmentStatus () {
      if ((!this.attachment.prev || this.prevAttachmentStatus) && !this.attachment.error && this.uploadStatus !== UploadStatus.COMPLETED) {
        this.executeFileScanAndUpload();
      }
    },
    attachmentDescription () {
      this.$emit(EventType.IMAGE_UPDATED, {
        url: this.uploadUrl,
        fileName: this.attachment.file.name,
        id: this.attachment.id,
        photoDescription: this.attachmentDescription ?? ''
      });
    }
  },
  mounted () {
    this.maxProgressUpdateLimit = getProgressBarSpeedlimit(this.attachment.file);
    if ((!this.attachment.prev || this.prevAttachmentStatus) && !this.attachment.error) {
      this.executeFileScanAndUpload();
    } else if (this.prevAttachment.id && !this.attachment.error) {
      this.uploadStatus = UploadStatus.SCANNING;
      const interval = setInterval(() => {
        this.updateProgress(2);
        if (this.progress > 16) {
          clearInterval(interval);
        }
      }, 300);
    }
  },
  methods: {
    handleImageError (event: Event) {
      (event.target as HTMLImageElement).src = require('@/assets/images/defaultHome.png')
    },
    updateProgress (maxLimit: number) {
      if (this.progress < 88) {
        const randomUnit = getRandomNumber(1, maxLimit);
        const diff = 100 - this.progress;
        if (randomUnit <= diff) {
          this.progress += randomUnit;
        } else {
          this.progress += diff;
        }
      }
    },
    async uploadFile () {
      this.uploadStatus = UploadStatus.UPLOADING;
      try {
        if (this.progress + 3 < 97) {
          this.progress += 3;
        }
        this.uploadUrl = this.scanData.url;
        if (this.jobId) {
          try {
            await uploadPhoto({
              collectionId: this.attachment.id,
              altTag: '',
              contentType: 'image',
              uploadedByEmailId: this.user.email,
              uploadedByType: 'BUYER',
              uploadedById: this.user.contactId,
              assetValue: this.uploadUrl,
              caption: this.attachmentDescription ?? '',
              name: this.attachment.file.name,
              categoryTypeId: '0',
              application: '',
              order: '0',
              jobId: this.jobId,
              isNewRecord: true
            } as Photos);
          } catch (error) {
            console.log(error);
          }
        }
        await uploadAttachment(this.scanData.awsPresignedUrl, this.attachment.file, this.scanData.contentType);
        this.progress = 100;
        this.uploadStatus = UploadStatus.COMPLETED;
        this.$emit(EventType.FILE_UPLOADED, {
          url: this.uploadUrl,
          fileName: this.attachment.file.name,
          id: this.attachment.id,
          photoDescription: this.attachmentDescription ?? ''
        });
      } catch (error) {
        this.handleUploadFailed();
      }
    },
    async scanFile () {
      this.uploadStatus = UploadStatus.SCANNING;
      try {
        this.base64FileData = await convertFileToBase64(this.attachment.file) as string;
        const response = await scanFile({
          fileName: this.attachment.file.name,
          file: this.base64FileData,
          fileType: this.attachment.file.type,
          messageThreadId: this.activeConversation ? this.activeConversation : '',
          jobId: this.jobId ? this.jobId : ''
        });
        this.scanData = response || {};
        if (isEmptyObject(this.scanData) || this.scanData.isInfected) {
          this.scanResult = 'File is infected';
          this.uploadStatus = UploadStatus.INFECTED;
          this.$emit(EventType.UPLOAD_INFECTED, {
            url: '',
            fileName: this.attachment.file.name,
            id: this.attachment.id
          });
        } else {
          this.uploadFile();
        }
      } catch (error) {
        this.handleUploadFailed();
      }
    },
    retryUpload () {
      this.uploadStatus = UploadStatus.PENDING;
      this.progress = 0;
      this.executeFileScanAndUpload();
    },
    handleUploadFailed () {
      this.uploadStatus = UploadStatus.UPLOAD_FAILED;
      this.resetData();
      this.$emit(EventType.UPLOAD_FAILED, {
        url: '',
        fileName: this.attachment.file.name,
        id: this.attachment.id
      });
    },
    executeFileScanAndUpload () {
      this.scanFile();
      const interval = setInterval(() => {
        this.updateProgress(this.maxProgressUpdateLimit.limit);
        if (this.progress === 100) {
          clearInterval(interval);
        }
      }, this.maxProgressUpdateLimit.interval);
    },
    resetData () {
      this.scanData = {};
      this.uploadUrl = '';
    },
    cancelFile () {
      this.$emit(EventType.REMOVE_FILE, { id: this.attachment.id, status: this.uploadStatus, fileName: this.attachment.file.name });
      BaseApi.cancelRequest();
    }
  }
})
